module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Add a user","submit":"Save"}}')
  delete Component.options._Ctor
}
